// indonesiaV2Language.ts
// ─── Astria Indonesia v2 — self-contained EN/ID language toggle ───────────
// Scoped entirely to this feature — does NOT touch the app-wide i18next
// setup (src/i18n.ts) or any other country lane. Persists only the
// Indonesia V2 screen's own language choice, independent of the account's
// global `preferredLanguage`. Same pattern as vietnamV2Language.ts.
import { useCallback, useEffect, useState } from "react";

export type IndonesiaV2Lang = "en" | "id";

const STORAGE_KEY = "astriaIndonesiaV2Lang";

export function getStoredIndonesiaV2Lang(): IndonesiaV2Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "id") return stored;
  } catch {
    // localStorage unavailable — fall through to default
  }
  return "id";
}

export function useIndonesiaV2Language(): [
  IndonesiaV2Lang,
  (lang: IndonesiaV2Lang) => void,
] {
  const [lang, setLangState] = useState<IndonesiaV2Lang>(
    getStoredIndonesiaV2Lang,
  );

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next: IndonesiaV2Lang) => {
    setLangState(next);
  }, []);

  return [lang, setLang];
}
